export default __webpack_public_path__ + "static/media/man.0ca075e5.png";